import * as React from "react";
const SvgFiRrTemperatureFrigid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-temperature-frigid_svg__a)">
      <path
        fill="#062147"
        d="M17.008 23.976c-6.046.116-9.284-7.597-4.973-11.826V5.077c.21-6.573 9.738-6.564 9.946 0v7.073c4.312 4.23 1.071 11.942-4.973 11.826m0-21.882a2.984 2.984 0 0 0-2.984 2.983v7.497c0 .282-.12.551-.33.74a4.973 4.973 0 1 0 6.628 0 1 1 0 0 1-.33-.74V5.077a2.984 2.984 0 0 0-2.984-2.983m0 17.903a2.991 2.991 0 0 1-.995-5.798V8.061a.995.995 0 1 1 1.99 0V14.2a2.99 2.99 0 0 1-.995 5.798m0-3.979a.995.995 0 1 0 0 1.99.995.995 0 0 0 0-1.99m-10.715-.856a1 1 0 0 1-.704-1.698l1.05-1.051a2 2 0 0 1 .423-.323v-1.08a3.47 3.47 0 0 1-1.833-.86l-.953.554q.003.268-.066.526l-.381 1.438a.995.995 0 0 1-1.924-.51l.382-1.437-1.447-.398A.995.995 0 1 1 1.35 8.4l1.435.381q.256.068.489.2l.917-.533a3.5 3.5 0 0 1 .01-1.811l-.925-.535a2 2 0 0 1-.49.199l-1.438.38A.995.995 0 1 1 .84 4.76l1.437-.38-.37-1.454a.995.995 0 1 1 1.923-.51l.38 1.438q.071.26.067.526l.983.571a3.48 3.48 0 0 1 1.802-.833l-.01-1.01a2 2 0 0 1-.425-.325l-1.05-1.051A.995.995 0 0 1 6.981.326l1.051 1.051 1.07-1.05a.995.995 0 1 1 1.407 1.406l-1.051 1.05a2 2 0 0 1-.42.322l.012 1.972c0 .55-.446.995-.995.995H7.56a1.492 1.492 0 0 0 0 2.984h.497c.55 0 .995.445.995.995v2.77c0 .549-.446.994-.995.994l-1.06 1.056a1 1 0 0 1-.703.291"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-temperature-frigid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTemperatureFrigid;
